module.exports = "pegasus_template/assets/theme3/img1.png";